const comments = [
  {
    name: '吃瓜不嫌事大',
    avatar: '🍉',
    time: '3分钟前',
    content: '这个瓜我吃了三天了，每天都有新进展，51爆料的更新速度真的快，比微博热搜还及时！',
    likes: 128,
    tag: '铁粉',
  },
  {
    name: '八卦研究员',
    avatar: '🔍',
    time: '15分钟前',
    content: '之前在其他平台看到的消息都不全，来51爆料才把来龙去脉搞清楚，整理得太详细了，爱了爱了。',
    likes: 96,
    tag: '活跃',
  },
  {
    name: '今天吃瓜了吗',
    avatar: '👀',
    time: '32分钟前',
    content: '每日必刷51爆料，已经成为我的摸鱼神器了。今天的热搜榜前三名都很有料，推荐大家都看看！',
    likes: 75,
    tag: '',
  },
  {
    name: '娱乐圈观察家',
    avatar: '🎬',
    time: '1小时前',
    content: '这个月度盘点的专题做得太用心了，把最近一个月的大瓜按时间线整理得清清楚楚，收藏了！',
    likes: 63,
    tag: '',
  },
  {
    name: '追剧小达人',
    avatar: '📺',
    time: '2小时前',
    content: '影视争议那个专题说出了我的心声！现在的改编剧真的太离谱了，原著粉表示强烈不满。',
    likes: 51,
    tag: '新用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            网友热议
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            看看吃瓜群众们都在讨论什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-lg flex-shrink-0">
                  {comment.avatar}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-900">
                      {comment.name}
                    </span>
                    {comment.tag && (
                      <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                        {comment.tag}
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
                <div className="flex items-center gap-1 text-foreground-500">
                  <i className="ri-thumb-up-line text-sm"></i>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed pl-12">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}